import cn from 'classnames';
import { Children } from 'types/base.types';

const Typography = ({ children, className }: { children: Children; className?: string }) => (
  <p className={cn('p0 text-align-center', className)}>{children}</p>
);

export default Typography;
